// extracted by mini-css-extract-plugin
module.exports = {"section":"Videos_section__CrtP8","categories":"Videos_categories__2WueF","category_label":"Videos_category_label__12J3a","category_active":"Videos_category_active__qzTLS"};